(function () {
    'use strict';

    angular
        .module('elogbooksServices')
        .service('elbDownloadService', ElbDownloadService);

    ElbDownloadService.$inject = ['$http', 'API_URL', 'messenger'];

    function ElbDownloadService($http, API_URL, messenger) {
        function extractFilenameFromContentDisposition(contentDisposition) {
            if (!contentDisposition) {
                return null;
            }

            var match = contentDisposition.match(/filename=([^;]+)/i);
            if (match && match[1]) {
                return match[1].trim().replace(/^"(.*)"$/, '$1');
            }

            return null;
        }

        function isValidFile (file) {
            return file._links && file._links.self;
        }

        function isDownloadableFile (file) {
            return isValidFile(file) && file._links.resource;
        }


        return {
            getLink: function (file) {
                if (! isValidFile(file)) {
                    return;
                }

                return file._links.self.href;
            },
            download: function (file) {
                if (! isDownloadableFile(file)) {
                    return;
                }

                $http.get(file._links.resource.href, { responseType: "arraybuffer" }).then(function (response) {
                    var arrayBufferView = new Uint8Array(response.data);
                    var blob = new Blob([arrayBufferView], { type: file._links.resource.type });

                    if (navigator.msSaveBlob) {
                        // Internet Explorer
                        navigator.msSaveBlob(blob, file.filename);
                    } else {
                        // Proper browsers
                        var anchor = angular.element('<a />');
                            anchor.css({display: 'none'});

                        angular.element(document.body).append(anchor);

                        var urlCreator = window.URL || window.webkitURL;
                        var url = urlCreator.createObjectURL(blob);

                        anchor.attr({
                            href: url,
                            download: file.filename
                        })[0].click();

                        anchor.remove();
                    }
                }).catch(function () {
                    messenger.error('REQUEST_ERROR');
                });
            },
            downloadUrl: function (url, fileName, fileType, fullPath) {
                if (!fullPath) {
                    url = API_URL + url;
                }

                return $http.get(url, { responseType: "arraybuffer" }).then(function (response) {
                    var responseContentType = response.headers('Content-Type') || fileType || 'application/octet-stream';
                    var responseFileName = extractFilenameFromContentDisposition(response.headers('Content-Disposition')) || fileName;
                    var arrayBufferView = new Uint8Array(response.data);
                    var blob = new Blob([arrayBufferView], { type: responseContentType });

                    if (navigator.msSaveBlob) {
                        // Internet Explorer
                        navigator.msSaveBlob(blob, responseFileName);
                    } else {
                        var anchor = angular.element('<a />');
                            anchor.css({display: 'none'});

                        angular.element(document.body).append(anchor);

                        var urlCreator = window.URL || window.webkitURL;
                        var url = urlCreator.createObjectURL(blob);

                        anchor.attr({
                            href: url,
                            download: responseFileName
                        })[0].click();

                        anchor.remove();
                    }
                });
            }
        }
    }
})();
